// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"148":"6574455c","174":"aa1ea377","339":"acadecfc","354":"ff100388","583":"770c64df"}[chunkId] + ".chunk.js";
};